const homeComponant = {
  text: '[EN] - Home page',
  componant: {
    name: 'home',
  },
};

export default {
  navbar: {
    menus: [
      {
        name: 'Producers',
        code: 'PROVIDERS',
      },
      {
        name: 'Products',
        code: 'PRODUCTS',
        // subMenuGroups: [
        //   {
        //     title: 'Agency',
        //     items: [
        //       {
        //         name: 'Wines',
        //         code: 'WINE',
        //       },
        //       {
        //         name: 'Ciders',
        //         code: 'CIDER',
        //       },
        //       {
        //         name: 'Beers',
        //         code: 'BEER',
        //       },
        //       {
        //         name: 'Alcohols',
        //         code: 'ALCOHOL',
        //       },
        //       {
        //         name: 'Aperitifs',
        //         code: 'APERITIF',
        //       },
        //     ],
        //   },
        // ],
      },
      {
        name: 'Shop',
        code: 'BOUTIQUE',
        subMenuGroups: [
          {
            title: 'Shop',
            items: [
              {
                name: 'Montreal',
                code: 'MONTREAL',
                inventories: [
                  {
                    key: 'inventory',
                    value: 'STORE_MTL',
                  },
                ],
              },
              // {
              //   name: 'Quebec',
              //   code: 'QUEBEC',
              //   inventories: [
              //     {
              //       key: 'inventory',
              //       value: 'STORE_QC',
              //     },
              //   ],
              // },
              {
                name: 'Toronto',
                code: '',
                inventories: [
                  {
                    key: 'inventory',
                    value: 'STORE_TORONTO',
                  },
                ],
              },
            ],
          },
        ]
      },
      {
        name: 'Clients',
        code: 'CLIENTS',
        // subMenuGroups: [
          // {
            // title: 'Abonnement',
            // items: [
              // {
              //   type: 'single',
              //   name: 'Member',
              //   path: '/membres'
              // },
              // {
              //   type: 'single',
              //   name: 'Discover',
              //   path: ''
              // },
            // ],
          // },
        // ]
      },
      {
        name: 'Blog',
        code: 'BLOG',
      },
    ],
    actionBar: {
      language: {
        label: 'Language',
        subMenuGroups: [
          {
            title: 'Language',
            items: [
              {
                code: 'EN',
                displayCode: 'EN',
                displayLabel: 'English',
                // Make sure `requestValue` map values in @/plugins/vue-i18n
                requestValue: 'en-US',
              },
              {
                code: 'FR',
                displayCode: 'FR',
                displayLabel: 'Français',
                // Make sure `requestValue` map values in @/plugins/vue-i18n
                requestValue: 'fr-CA',
              },
            ],
          },
        ],
      },
      country: {
        label: 'Province',
        subMenuGroups: [
          {
            title: 'Country',
            items: [
              {
                code: 'ON',
                displayCode: 'ON',
                displayLabel: 'Ontario',
              },
              {
                code: 'QC',
                displayCode: 'QC',
                displayLabel: 'Quebec',
              },
            ],
          },
        ],
      },
      tax: {
        label: 'Taxes',
        subMenuGroups: [
          {
            title: 'Taxes',
            items: [
              {
                code: 'IN',
                displayCode: 'Tax in',
                displayLabel: 'Included',
              },
              {
                code: 'OUT',
                displayCode: 'Tax ex',
                displayLabel: 'Excluded',
              },
            ],
          },
        ],
      },
    },
    previousBtnName: 'Menu',
    searchInput: {
      placeholder: 'Wine, year, provider, article, etc.',
    },
  },
  filterBar: {
    label: {
      filter: 'Filter',
      reset: 'Reset',
      sort: 'Sort by',
      print: 'Print',
      VueList: 'List view',
      VueTuiles: 'Tiles view'
    },
    sortOptions: [
      {
        value: '',
        label: 'Reset',
      },
      {
        value: 'sortByPrice=DESC',
        label: 'Price',
      },
      {
        value: 'sortByQty=DESC',
        label: 'Quantity',
      },
    ],
    sortBlogOptions: [
      {
        value: 'sortByDate=ASC',
        label: 'Oldest to Newest',
      },
      {
        value: 'sortByDate=DESC',
        label: 'Newest to Oldest ',
      },
    ],
    placeHolder: 'Sort by'
  },
  previousPageBtn: {
    agency: 'Agency products',
    boutique: 'Shop',
    providers: 'Producers',
    blog: 'Blogs',
    myAccount: 'My account',
    label: 'Back',
    FrequentlyAskedQuestions: 'Frequently Asked Questions',
    producer: 'Producer',
    montrealShop: 'Montreal Shop',
    quebecShop: 'Quebec Shop',
    torontoShop: 'Toronto Shop',
  },
  pagination: {
    label: 'Page {currentPage} of {totalNumberOfPage}',
  },
  noRecordsFound: 'No records found',
  footer: {
    menus: {
      menuAbout: {
        header: 'About',
        company: 'Company',
        restaurants: 'Shop',
        faq: 'FAQ',
        privacy: 'Privacy Policy',
      },
      menuAgency: {
        header: 'Agency',
        wines: 'Wines',
        ciders: 'Ciders',
        beers: 'Beers',
        alcools: 'Alcools',
        agence: 'Agency',
        boutiqueMontreal: 'Shop Montréal',
        boutiqueQuebec: 'Shop Québec',
        boutiqueToronto: 'Shop Toronto',
        order: 'Commander',
      },
      menuStore: {
        header: 'Alcohol free',
        wines: 'Wines',
        foods: 'Foods',
        goods: 'Goods',
        boisson: 'Beverage',
        epicerie: 'Grocery store',
        marchandise: 'Merchandise'
      },
      menuDiscovery: {
        header: 'Discover',
        producers: 'Producers',
        suscriptions: 'Suscriptions',
        blogs: 'Blog',
        becomeAMember: 'Become a Client',
        mixedCase: 'Mixed case',
        contact: 'Contact us',
        boutique: 'Boutique',
        member: 'Member',
      },
      menuProducts: {
        header: 'Products',
        wines: 'SAQ',
        BeersAndCiders: 'Private Import',
        nonAlcoholic : 'LCBO',
        oliveOil: 'Olive oil',
        food: 'Food',
        shops: 'Private Orders',
        divers: 'Miscellaneous'
      },
      menuProductsNew: {
        wines: 'Wine',
        spirits: 'Spirits',
        alcoholFree: 'Alcohol free',
        otherProducts: 'Other products', 
      },
      menuRestaurant: {
        header: 'Shop',
        menu: 'Menu',
        montreal: 'Montreal',
        toronto: 'Toronto',
      },
    },
    address: {
      montreal: {
        line1: '6422 Saint-Laurent',
        line2: '',
        line3: 'Montreal, QC, H2S 3C4',
      },
      toronto: {
        line1: '1583 Dupont',
        line2: 'Toronto, ON, M6P 3S5',
      },
    },
    allRightsReserved: 'Boires Inc. All rights reserved - BOIRES is a registered trademark of Boires Inc.',
    socialLink: {
      youtube: 'https://www.youtube.com/channel/UCIEjAJMsHkVba-H1rOdBqIg',
      instagram: 'https://www.instagram.com/boires.ca/',
      facebook: 'https://www.facebook.com/boires.ca/',
    }
  },
  notFound: {
    title: 'Oops, we could not find this page',
    type: {
      unknown: {
        links: [
          homeComponant,
        ],
      },
      blogs: {
        links: [
          homeComponant,
          {
            text: '[EN] - blog page',
            componant: {
              name: 'blogs',
            },
          },
        ],
      },
      products: {
        links: [
          homeComponant,
          {
            text: '[EN] -product page',
            componant: {
              name: 'products',
            },
          },
        ],
      },
      providers: {
        links: [
          homeComponant,
          {
            text: '[EN] - producers page',
            componant: {
              name: 'providers',
            },
          },
        ],
      },
    },
  },
  dispo: 'AVAIL'
};
